module.exports = __webpack_public_path__ + "media/src/images/icon__sad--1-e61c23ce3c98b8a79f6f61a26c32f7f7.png";